import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { BeneficiaryMovementTypeEnum } from './beneficiaryMovementType';
import type { MovementSummaryItemProps } from './types';

export const MOVEMENT_SUMMARY_ITEMS: MovementSummaryItemProps[] = [
  {
    key: BeneficiaryMovementTypeEnum.HOLDER_INCLUSION,
    color: NEW_COLORS.SEMANTICS.SUCCESS[600],
    label: 'Inclusão de titular',
    iconName: 'actions-b2b-add-user',
  },
  {
    key: BeneficiaryMovementTypeEnum.DEPENDENT_INCLUSION,
    color: NEW_COLORS.SEMANTICS.SUCCESS[600],
    iconName: 'medical-b2b-add-group',
    label: 'Inclusão de dependente',
  },
  {
    color: NEW_COLORS.SEMANTICS.ERROR[600],
    key: BeneficiaryMovementTypeEnum.EXCLUSION,
    iconName: 'actions-b2b-delete',
    label: 'Exclusão',
  },
  {
    key: BeneficiaryMovementTypeEnum.CADASTRAL_CHANGE,
    color: NEW_COLORS.SEMANTICS.INFO[600],
    label: 'Alteração',
    iconName: 'actions-b2b-edit',
  },
  {
    iconName: 'actions-b2b-transfer-file',
    key: BeneficiaryMovementTypeEnum.CONTRACT_TRANSFER,
    label: 'Transferência',
    color: NEW_COLORS.SECONDARY[500],
  },
  /* REMINDER: tipos de movimentação comentados a pedido da área de negócios
  {
    label: 'Aposentado e/ou demitido',
    color: COLORS.MONOCHROMATIC.GRAY4,
    iconName: 'account-multiple-plus',
    key: BeneficiaryMovementTypeEnum.RETIRED,
  },

  {
    key: BeneficiaryMovementTypeEnum.REACTIVATION,
    color: COLORS.PRIMARY.ORANGE['+1'],
    iconName: 'refresh',
    label: 'Reativação',
  },
  {
    key: BeneficiaryMovementTypeEnum.EXCLUSION_CANCELATION,
    color: COLORS.SECONDARY.RED['+1'],
    iconName: 'delete-scratched',
    label: 'Cancelar exclusão',
  },
  {
    color: COLORS.PRIMARY.ORANGE['+1'],
    key: BeneficiaryMovementTypeEnum.PLAN_CHANGE,
    iconName: 'swap-horizontal',
    label: 'Troca de plano',
  },
  */
];
